module.exports = __webpack_public_path__ + "img/icon_logo_violet.f64eacfa.svg";